module.exports = __webpack_public_path__ + "static/media/loading_w.755ce678.svg";